import './QuestionAssessment.scss'

import { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import { getAssessmentOptionsFromQuestion } from 'components/common/api/Quizzes'

/*
 * QuestionAssessment component. Used for displaying Likert-style assessment questions
 */
export default function QuestionAssessment({
  defaultValue = '',
  question,
  handleSaveResponse
}) {
  const [selection, setSelection] = useState(defaultValue)
  const options = getAssessmentOptionsFromQuestion(question)

  useEffect(() => {
    // Silence is golden :)
  }, [defaultValue, selection])

  return (
    question &&
    options && (
      <div className='assessment-question-wrapper'>
        {options.map(option => (
          <Form.Check
            inline
            key={option}
            label={option}
            name={question.question_id}
            type='radio'
            checked={option === selection}
            onChange={_ => {
              setSelection(option)
              handleSaveResponse(option)
            }}
          />
        ))}
      </div>
    )
  )
}
